export const DashboardSkeletonSVG = ({ width = 134, height = 86, ...props }) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 134 86'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <rect y='0.614868' width='134' height='84.7702' rx='8' fill='#CEBDE6' />
        <rect x='7' y='8.61487' width='75' height='45.5901' rx='4' fill='white' />
        <g clipPath='url(#clip0_64365_344219)'>
            <rect x='15' y='16.6149' width='37.2671' height='8' rx='2' fill='#E9E1F4' />
        </g>
        <g clipPath='url(#clip1_64365_344219)'>
            <rect x='15' y='27.4099' width='42' height='8' rx='2' fill='#E9E1F4' />
        </g>
        <rect x='59.795' y='27.4099' width='13' height='8' rx='2' fill='#E9E1F4' />
        <rect x='15' y='38.205' width='59' height='8' rx='2' fill='#E9E1F4' />
        <rect x='90' y='8.61487' width='37' height='34.795' rx='4' fill='white' />
        <rect x='98' y='16.6149' width='13' height='8' rx='2' fill='#E9E1F4' />
        <rect x='98' y='27.4099' width='21' height='8' rx='2' fill='#E9E1F4' />
        <rect x='90' y='47.4099' width='37' height='29.9752' rx='4' fill='white' />
        <rect x='98' y='55.4099' width='21' height='8' rx='2' fill='#E9E1F4' />
        <defs>
            <clipPath id='clip0_64365_344219'>
                <rect x='15' y='16.6149' width='37.2671' height='8' rx='2' fill='white' />
            </clipPath>
            <clipPath id='clip1_64365_344219'>
                <rect x='15' y='27.4099' width='42' height='8' rx='2' fill='white' />
            </clipPath>
        </defs>
    </svg>
);
